import { UIBrandCorner } from '@headless-workspace/core-ui';
import { InnerHTML } from '@headless-workspace/domain/common/client';
import { BrandCornerBannerValue } from '@headless-workspace/domain/common/server';
import { PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

const BRAND_CORNER_SECTION_ID = 'brand-corner-section';

type ProductDetailBrandCornerSectionProps = {
    brandCornerBanner: BrandCornerBannerValue;
} & PropsWithFontFamily;

export const ProductDetailBrandCornerSection: Component<ProductDetailBrandCornerSectionProps> = ({
    fontFamily,
    brandCornerBanner,
}) => {
    return (
        <section id={BRAND_CORNER_SECTION_ID} className={'flex flex-col gap-2 pb-2 desktop:pb-4 px-1 desktop:px-5.5'}>
            <UIBrandCorner
                content={{
                    title: {
                        text: <InnerHTML rawHtml={{ content: brandCornerBanner.title }} />,
                        TagName: 'h2',
                        fontFamily,
                    },
                    description: {
                        text: <InnerHTML rawHtml={{ content: brandCornerBanner.description }} />,
                        fontFamily,
                    },
                    button: {
                        cta: brandCornerBanner.button,
                        width: 'responsive',
                        fontFamily,
                    },
                }}
                image={{
                    src: brandCornerBanner.image,
                }}
            />
        </section>
    );
};
